import React from "react";
import { Link } from "react-router-dom";
// Import existing components
import Carousel from "./Carousel";
import UserPageProdSlider from "./UserPageProdSlider";
import OfferSwiper from "./OfferSwiper";
import NewArrivalsSwiper from "./NewArrivalSwiper";
import Categories from "./Categories";
import TrendingProductsSection from "./TrendingProductsSection";
import TestimonialPage from "./TestimonialPage";
import { motion } from "framer-motion";
import ReelsComponent from "./ReelsComponent";
import mashoperfumes from "../../assets/images/Masho_making 1.jpg";
import ReviewContainer from "./ReviewContainer";

export default function HomePage() {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow">
        {/* Carousel Section */}
        <section className="relative z-40">
          <Carousel />
        </section>

        {/* Your Perfect Scent Awaits Section */}
        <section className="pt-12 pb-5 px-4 md:px-8 max-w-7xl mx-auto bg-gradient-to-b from-gray-50 to-white">
           {/* Section Header */}
           <div className="text-center mb-0">
             <h2
               className="text-2xl md:text-4xl text-[#333333] mb-2 tracking-wide"
               style={{ fontFamily: "serif" }}
             >
               Your Perfect Scent Awaits!
             </h2>
             <p className="text-sm md:text-base text-gray-500 max-w-md mx-auto">
               Discover our exclusive collection of premium fragrances crafted for elegance.
             </p>
             <div className="mt-4 h-1 w-20 bg-[#D4AF37] mx-auto rounded-full"></div>
           </div>

           {/* Product Slider */}
           <div className="w-full overflow-hidden relative mt-8">
             <div className="absolute inset-0 -z-10 bg-gradient-to-r from-transparent via-[#D4AF37]/10 to-transparent"></div>
             <UserPageProdSlider />
           </div>
         </section>

        {/* Featured Reels Section */}
        <section className="pt-8 pb-8 px-4 md:px-8 max-w-7xl mx-auto bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
          {/* Decorative Background Overlay */}
          <div className="absolute inset-0 -z-10 bg-gradient-to-r from-transparent via-[#D4AF37]/10 to-transparent"></div>

          <div className="text-center mb-10 relative z-10">
            <h2
              className="text-2xl md:text-4xl bg-gradient-to-r from-[#D4AF37] to-[#C19B2E] text-transparent bg-clip-text mb-2 tracking-wide"
              style={{ fontFamily: "serif" }}
            >
              <span className="text-[#D4AF37] mr-2">✨</span>
              SEE IT IN ACTION
              <span className="text-[#D4AF37] ml-2">✨</span>
            </h2>
            <p className="text-sm md:text-base text-gray-500 max-w-md mx-auto">
              Dive into the world of MASHO Perfumes.
            </p>
            <div className="mt-2 h-1 w-20 bg-gradient-to-r from-[#D4AF37] to-[#C19B2E] mx-auto rounded-full"></div>
          </div>

          {/* Reels Slider */}
          <div className="w-full relative">
            <ReelsComponent />
          </div>
        </section>

        {/* Categories Section */}
        <section className="pt-5">
          <Categories />
        </section>

        {/* New Arrivals Section */}
        <section className="pt-5 py-12 px-4 md:px-8 max-w-7xl mx-auto bg-gradient-to-b from-gray-50 to-white">
          {/* Section Header */}
          <div className="text-center mb-8">
            <h2
              className=" text-2xl md:text-4xl bg-gradient-to-r from-[#D4AF37] to-[#C19B2E] text-transparent bg-clip-text mb-2 tracking-wide animate-pulse"
              style={{ fontFamily: "serif" }}
            >
              Freshly Unveiled Scents!
            </h2>
            <p className="text-sm md:text-base text-gray-500 max-w-md mx-auto">
              Explore our latest fragrances, crafted to captivate and inspire.
            </p>
            <div className="mt-4 h-1 w-20 bg-[#D4AF37] mx-auto rounded-full"></div>
          </div>

          {/* New Arrivals Swiper */}
          <div className="w-full overflow-hidden relative">
            <div className="absolute inset-0 -z-10 bg-gradient-to-r from-transparent via-[#D4AF37]/10 to-transparent"></div>
            <NewArrivalsSwiper />
          </div>
        </section>

        {/* Masho Studio Section */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="pt-5 py-12 px-4 md:px-8 max-w-7xl mx-auto bg-gradient-to-b from-gray-50 to-white relative overflow-hidden"
        >
          {/* Decorative Background Overlay */}
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1615015059497-4783b7a5d7b8?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center opacity-10"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-[#D4AF37]/10 to-transparent"></div>

          {/* Content Container */}
          <div className="relative z-10 flex flex-col md:flex-row items-center gap-8">
            {/* Left Side - Image */}
            <div className="md:w-1/2">
              <div className="relative group">
                <img
                  src={mashoperfumes}
                  alt="Luxurious Perfume Bottle"
                  className="w-full h-64 md:h-96 object-cover rounded-sm shadow-lg transition-all duration-300 group-hover:scale-105 group-hover:shadow-xl"
                />
                {/* Subtle Gold Border on Hover */}
                <div className="absolute inset-0 border-4 border-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-sm"></div>
              </div>
            </div>

            {/* Right Side - Text and Button */}
            <div className="md:w-1/2 text-center md:text-left">
              <h2 className="text-2xl md:text-4xl text-[#333333] mb-4 tracking-wide relative pb-2">
                Design and Gift Perfumes with Masho Studio!
                {/* Gold Underline */}
                <span className="absolute bottom-0 left-0 md:left-0 w-20 h-1 bg-[#D4AF37] rounded-full"></span>
              </h2>
              <p className="text-sm md:text-base text-gray-500 mb-6 max-w-md mx-auto md:mx-0">
                Unleash your creativity and craft a unique perfume bottle that reflects your style.
              </p>
              <Link
                to="/masho-studio"
                className="inline-block bg-gradient-to-r from-[#D4AF37] to-[#C19B2E] text-black px-6 py-3 rounded-sm text-sm font-medium hover:from-[#C19B2E] hover:to-[#B08927] transition-all duration-200 transform hover:scale-105 shadow-md hover:shadow-lg hover:ring-4 hover:ring-[#D4AF37]/50"
              >
                Explore Masho Studio
              </Link>
            </div>
          </div>
        </motion.section>

        {/* Trending Products Section */}
        <section className="pt-12">
          <TrendingProductsSection />
        </section>

        {/* Offers Section */}
        <section className="pt-12 py-5 px-4 md:px-8 max-w-7xl mx-auto bg-gradient-to-b from-gray-50 to-white">
          {/* Section Header */}
          <div className="text-center mb-0">
            <h2
              className=" text-2xl md:text-4xl text-[#333333] mb-2 tracking-wide"
              style={{ fontFamily: "serif" }}
            >
              Exclusive Offers Just for You!
            </h2>
            <p className="text-sm md:text-base text-gray-500 max-w-md mx-auto">
              Don't miss out on our limited-time offers on premium fragrances!
            </p>
            <div className="mt-4 h-1 w-20 bg-[#D4AF37] mx-auto rounded-full"></div>
          </div>

          {/* Offer Swiper */}
          <div className="w-full overflow-hidden relative mt-8">
            <div className="absolute inset-0 -z-10 bg-gradient-to-r from-transparent via-[#D4AF37]/10 to-transparent"></div>
            <OfferSwiper />
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="pt-12 py-5 px-4 md:px-8 max-w-7xl mx-auto bg-gradient-to-b from-gray-50 to-white">
          <div className="text-center mb-0">
            <h2
              className=" text-2xl md:text-4xl text-[#333333] mb-2 tracking-wide"
              style={{ fontFamily: "serif" }}
            >
              What Our Customers Say!
            </h2>
            <p className="text-sm md:text-base text-gray-500 max-w-md mx-auto">
              Hear from our satisfied customers about their MASHO experience.
            </p>
            <div className="mt-4 h-1 w-20 bg-[#D4AF37] mx-auto rounded-full"></div>
          </div>
          <ReviewContainer />
        </section>

      </main>
    </div>
  );
}